import { createContext, useReducer } from "react";

export const SnapshotContext = createContext(null);
export const SnapshotDispatchContext = createContext(null);


export function SnapshotProvider({children}) {
    const [snapshot, dispatch] = useReducer(snapshotReducer, initialSnapshot);

    return (
        <SnapshotContext.Provider value={snapshot}>
            <SnapshotDispatchContext.Provider value={dispatch}>
                {children}
            </SnapshotDispatchContext.Provider>
        </SnapshotContext.Provider>
    )
}

export function snapshotReducer(snapshot,action) {
    console.log(action);
    switch(action.type) {
        case 'changed': { 
            return action.selectedSnapshot; 
        }
        default: {
            throw Error('Unknown action: ' + action.type);    
        }
    }
}

const initialSnapshot = {
    'id': 1,
    'snap_name': 'Baza domyślna',
    'snap_prefix': "830017",
    'snap_creation_date': '2024-02-25 00:43:50',
    'snap_modify_date': '2024-02-25 00:43:50',
    'snap_description': 'Domyślna baza danych utworzona przez system KOMIN',
    'snap_status': 0,
    'snap_creator': 1
}